/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { CircularProgress, makeStyles, Tooltip } from "@material-ui/core";

import "./style.css";
import { getRequest } from "utils/request";
import { putRequest } from "utils/request";

import { translate } from "../../../translate/i18n";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Swal from "sweetalert2";
import TabNewBot from "./NewBot";

export default function TabBotConfig({
  companyData,
  handleUpdate,
  match,
  update,
}) {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [photo, setPhoto] = useState("");
  const [previewphoto, setPreviewPhoto] = useState("");
  const [globalFilter, setGlobalFilter] = useState("");
  const [onlyActive, setOnlyActive] = useState(true);
  const [updateBots, setUpdateBots] = useState(0);
  const [bots, setBots] = useState([]);
  const [selectedBot, setSelectedBot] = useState();
  const [newBot, setNewBot] = useState(false);

  const useStyles = makeStyles((theme) => ({
    customWidth: {
      fontSize: 16,
    },
  }));
  const classes = useStyles();

  const loadBots = () => {
    setLoading(true);
    getRequest(
      `/bots?companyId=${companyData.id}&onlyActive=${onlyActive ? 1 : 0}`
    ).then(async function (response) {
      if (response.data) {
        response.data.forEach((bot) => {
          const index = companyData.CompanyChannels.findIndex(
            (e) => e.BotId === bot.id
          );
          if (index >= 0) {
            bot.isLinked =
              companyData.CompanyChannels[index].Channel.description;
          }
        });
        setBots(response.data);
      }
    });
    getRequest(`/bots/config?CompanyId=${companyData.id}`).then(function (
      response
    ) {
      if (response.data) {
        setName(response.data.name);
        setPhoto(response.data.photo);
        setPreviewPhoto(response.data.photo);
      }
    });
    setLoading(false);
  };

  const updateAllBots = () => {
    setUpdateBots(updateBots + 1);
  };

  useEffect(() => {
    loadBots();
  }, [onlyActive, updateBots, update]);

  const handleInactive = (data) => {
    Swal.fire({
      title: translate("attemption"),
      text: translate("deleteBot"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: translate("confirmEraseBot"),
    }).then((result) => {
      if (result.isConfirmed) {
        putRequest(`/bots/inactive/${data}`).then((e) => {
          if (e.success) {
            setBots(bots.filter((e) => e.id !== data));
          }
        });
      }
    });
  };

  const actionButtonsTemplate = (data) => {
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          className="action-icon"
          style={{ cursor: "pointer", marginRight: 10 }}
          onClick={() => setSelectedBot(data)}
        >
          <i className="mdi mdi-pencil" style={{ fontSize: 20 }}></i>
        </div>
        {data.isLinked ? (
          <Tooltip
            arrow
            classes={{ tooltip: classes.customWidth }}
            title={
              translate("botLinked") +
              ` ${data.isLinked}` +
              translate("botLinked2")
            }
          >
            <button
              className="action-icon"
              style={{
                cursor: "pointer",
                background: "transparent",
                border: "none",
                opacity: "20%",
              }}
            >
              <i className="mdi mdi-delete" style={{ fontSize: 20 }}></i>
            </button>
          </Tooltip>
        ) : (
          <button
            className="action-icon"
            disabled={!data.active}
            style={{
              cursor: "pointer",
              background: "transparent",
              border: "none",
            }}
            onClick={() => handleInactive(data.id)}
          >
            <i className="mdi mdi-delete" style={{ fontSize: 20 }}></i>
          </button>
        )}
      </div>
    );
  };

  const sendData = () => {
    setLoading(true);

    const formData = new FormData();
    formData.append("name", name);
    formData.append("avatar", photo);

    putRequest(`/bots/config/${companyData.id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then(function (response) {
      setLoading(false);
      handleUpdate(14);
    });
  };

  const header = (
    <div className="data-table-header">
      <div
        className="checkbox-container"
        style={{ position: "absolute", left: 0 }}
      >
        <input
          checked={onlyActive}
          onChange={() => setOnlyActive(!onlyActive)}
          type="checkbox"
          className="checkbox"
          style={{ marginRight: 10 }}
        />
        <label>{translate("showInactive")}</label>
      </div>
      <i className="pi pi-search" style={{ paddingRight: 10 }}></i>
      <input
        className="input-globalfilter"
        type="search"
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Buscar"
        icon="pi pi-search"
      />
    </div>
  );

  const handleUploadLogo = (file) => {
    setPreviewPhoto(URL.createObjectURL(file.target.files[0]));
    setPhoto(file.target.files[0]);
  };

  return !loading ? (
    <div className="list-container">
      {!newBot && !selectedBot ? (
        <>
          <div className="title-helper-container" style={{ marginBottom: 20 }}>
            <h3>{companyData.nickName}</h3>
          </div>
          <form
            className="form-edit"
            style={{ minHeight: "25vh" }}
            onSubmit={(e) => {
              e.preventDefault();
              sendData();
            }}
          >
            <div className="form-row">
              <div className="form-group col-md-4">
                <label>{translate("name")} *</label>
                <input
                  type="text"
                  className="form-control"
                  value={name}
                  maxLength={30}
                  required
                  onChange={(value) => setName(value.target.value)}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <label>{translate("logo")}</label>
                <input
                  type="file"
                  className="form-control-file"
                  onChange={handleUploadLogo}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="area-img-company-logo-config">
                {previewphoto && (
                  <img
                    src={previewphoto}
                    className="img-company-logo-config"
                    alt="Bot"
                  />
                )}
              </div>
            </div>

            <div
              className="button-list mt-3 pull-right"
              style={{
                marginLeft: "auto",
                margin: "0 !important",
                marginBottom: 20,
              }}
            >
              <button type="submit" className="btn btn-outline-success">
                <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                {translate("save")}
              </button>
            </div>
          </form>
          <div className="tab-content">
            <div className="tab-pane show active" id="basic-datatable-preview">
              <DataTable
                header={header}
                globalFilter={globalFilter}
                dataKey="id"
                rowsPerPageOptions={[5, 10, 25, 50]}
                value={bots}
                paginator
                rows={5}
                emptyMessage={translate("noBotFinded")}
              >
                <Column
                  style={{ overflowWrap: "break-word" }}
                  field="description"
                  header={translate("description")}
                ></Column>
                <Column
                  style={{ overflowWrap: "break-word" }}
                  header={translate("callAgent")}
                  field="wordsCallOperator"
                ></Column>
                <Column
                  style={{ overflowWrap: "break-word" }}
                  header={translate("errorsBeforeAgent")}
                  field="numberOfRetries"
                ></Column>
                <Column
                  style={{ overflowWrap: "break-word" }}
                  header={translate("messageToAgent")}
                  field="OperatorMessage"
                ></Column>
                <Column
                  body={actionButtonsTemplate}
                  style={{ width: "10%" }}
                  header={translate("action")}
                ></Column>
              </DataTable>
              <div
                className="button-add-relative"
                onClick={() => setNewBot(true)}
              >
                <i className="mdi mdi-plus"></i>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div>
          <TabNewBot
            selectedEditBot={selectedBot}
            companyId={companyData.id}
            setSelectedBot={setSelectedBot}
            updateBots={updateAllBots}
            setNewBot={setNewBot}
            match={match}
          />
        </div>
      )}
    </div>
  ) : (
    <div className="area-loading">
      <CircularProgress />
    </div>
  );
}
